export default __webpack_public_path__ + "static/media/onboardingPost.46b2e161.svg";